import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsFacet, ConvertedComponentData, FsCatalog, TextInput } from '../../../types'
import {
  CmsConverterService, defaultFSCatalog, defaultFSFacet, defaultTextInput
} from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ProductFinderAnswerTileWithOptionsConverter extends CmsConverterService<ProductFinderAnswerTileWithOptionsData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_alt_text?.value
    const title = formData.st_title_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      items: formData.st_content ?? defaultFSCatalog,
      headline: formData.st_headline ?? defaultTextInput,
      facet: formData.pt_tag[0] ?? defaultFSFacet,
      image: CmsConverterService.mapImage(formData?.st_image, lazyLoad, altText, title).xl,
    }
  }
}

export const PRODUCT_FINDER_ANSWER_TILE_WITH_OPTIONS_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ProductFinderAnswerTileWithOptionsData>>('ProductFinderAnswerTileWithOptionsConverter')

export interface ProductFinderAnswerTileWithOptionsData extends ConvertedComponentData {
  items: FsCatalog<{ facet: CmsFacet }>;
  headline: TextInput;
  facet: CmsFacet;
  image: string;
}
